import { DataResponse } from '../models';
import { Config } from '../models/config';
import { Axios } from './axios';

export const getConfig = async () => (await Axios.get<DataResponse<Config>>(
  '/config',
  {
    transformRequest: (data, headers) => {
      headers.delete('Authorization');
      return data;
    },
  },
)).data.data;
